import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Layers, Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  const trustPills = [{
    icon: FileText,
    text: '100% PDF'
  }, {
    icon: Zap,
    text: 'Acceso en 5 min'
  }, {
    icon: Layers,
    text: 'Todos los niveles'
  }, {
    icon: Shield,
    text: 'Garantía 7 días'
  }, {
    icon: Lock,
    text: 'Pago seguro'
  }, {
    icon: CreditCard,
    text: 'Mercado Pago'
  }];
  return <section className="relative pt-8 pb-12 px-6 lg:pt-12 lg:pb-16 max-w-5xl mx-auto overflow-hidden" data-id="element-165">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="flex flex-col items-center text-center gap-4 z-10" data-id="element-166">
        <div className="inline-flex items-center gap-2 text-tealBrand font-bold tracking-wider text-sm uppercase" data-id="element-167">
          <span className="text-xl" data-id="element-168">🏫</span> BIBLIOTECAS DIGITALES™
        </div>

        <h1 className="text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight text-white" data-id="element-169">
          Todo tu año docente.
          <br data-id="element-170" />
          <span className="text-tealBrand" data-id="element-171">Listo. Desde hoy.</span>
        </h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative w-full max-w-sm my-2" data-id="element-172">
          <div className="absolute inset-0 bg-tealBrand/25 blur-[100px] rounded-full" data-id="element-173"></div>
          <img src="https://cdn.magicpatterns.com/uploads/uNem8eJVPufzFY1kFEfcki/mockup_sin_fondo.png" alt="MegaPack Docente Mockup" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-174" />
        </motion.div>

        <p className="text-gray-200 font-medium text-[14px]" data-id="element-175">
          El sistema N°1 para docentes argentinos — Primaria y Secundaria
        </p>

        <p className="text-gray-300 max-w-3xl text-[12px]" data-id="element-176">
          Planificaciones + evaluaciones + informes + actos + material visual
          listos para usar. Sin improvisar. Sin planificar domingos. Sin repetir
          trabajo.
        </p>

        <div className="flex flex-wrap justify-center mt-2 gap-[8px]" data-id="element-177">
          {trustPills.map((pill, idx) => <div key={idx} className="flex items-center gap-1.5 bg-petroleo border border-tealBrand/30 rounded-full px-3 py-1.5 text-sm font-medium text-white" data-id="element-178">
              <pill.icon className="w-4 h-4 text-tealBrand" data-id="element-179" />
              {pill.text}
            </div>)}
        </div>

        <div className="mt-2" data-id="element-180">
          <button onClick={() => document.getElementById('cta-megapack')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })} className="w-full sm:w-auto bg-amarillo hover:bg-amarilloHover text-noche font-bold text-lg px-8 py-4 rounded-xl shadow-lg hover:shadow-amarillo/20 transition-all transform hover:scale-[1.02] flex items-center justify-center gap-2" data-id="element-181">
            ⚡ QUIERO DEJAR DE TRABAJAR LOS DOMINGOS 📚
          </button>
        </div>
      </motion.div>
    </section>;
}